import {
    CollectionViewer,
    DataSource,
    ListRange,
} from '@angular/cdk/collections';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Injector, WritableSignal, signal } from '@angular/core';
import {
    BehaviorSubject,
    Observable,
    Subscription,
    distinctUntilChanged,
    noop,
} from 'rxjs';
import { IDatiqTableRow } from '../../datiq-table-row';
import { IDatiqTable, IDatiqTablePage, emptyDatiqTablePage } from '../models';
import { DatiqTableMapperService } from './datiq-table-mapper.service';

export class DatiqTableScrollService extends DataSource<
    IDatiqTableRow | undefined
> {
    private readonly _dataStream = new BehaviorSubject<
        (IDatiqTableRow | undefined)[]
    >([]);
    private readonly _subscription = new Subscription();
    private readonly _viewChange = new BehaviorSubject<IDatiqTablePage>({
        ...emptyDatiqTablePage,
    });
    private _table: WritableSignal<IDatiqTable>;
    private _viewPort: CdkVirtualScrollViewport;
    constructor(
        _table: WritableSignal<IDatiqTable>,
        _mapper: DatiqTableMapperService,
        cdkVirtualScrollViewport: CdkVirtualScrollViewport,
        _injector: Injector,
        _loaded: WritableSignal<boolean> = signal(false),
    ) {
        super();

        this._table = _table;
        this._viewPort = cdkVirtualScrollViewport;
        this.addToDataStream();
        this._viewChange.next({
            ...emptyDatiqTablePage,
            size: this._table()?.pageSize,
            elements: this._table()?.rows?.length,
        });
    }

    addToDataStream() {
        this._dataStream.next(this._table()?.rows);
    }

    connect(
        collectionViewer: CollectionViewer,
    ): Observable<readonly IDatiqTableRow[]> {
        this._subscription.add(
            collectionViewer.viewChange.subscribe((range: ListRange) => {}),
        );
        this._subscription.add(
            this._dataStream.pipe(distinctUntilChanged()).subscribe(() => {
                setTimeout(() => {
                    !!this._viewPort
                        ? this._viewPort.checkViewportSize()
                        : noop();
                }, 10);
            }),
        );

        return this._dataStream;
    }
    disconnect(collectionViewer: CollectionViewer): void {
        this._subscription.unsubscribe();
    }
    addRows(rows: IDatiqTableRow[]): void {
        this._dataStream.next([...this._dataStream?.value, ...rows]);
    }
}
